// removed by extract-text-webpack-plugin
module.exports = {"catButton":"Menu__catButton__DkvZM","menu":"Menu__menu__1mVeJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Menu/Menu.css
// module id = 99
// module chunks = 0